module.exports = __webpack_public_path__ + "static/media/14.2dc80c0b.png";